import React from "react";
import MovieCard from "./MovieCard";

import { ContainerMorePortfolio } from "./StyledComponents/ShowMore.style";
import BackgroundAbstract from "./asset/pictures/Free_Illustrations/Growth Colour/growth.svg";
import BackgroundAbstractBis from "./asset/pictures/Free_Illustrations/Idea Colour/idea1.svg";
import SorryImLate from "./asset/video/SorryImLate.mp4";
import Yoship from "./asset/video/Yoship.mp4";
import Slack_Clone from "./asset/video/Slack_Clone.mp4";

const MorePortfolio = () => {
  return (
    <>
      <ContainerMorePortfolio>
        <div>
          <img src={BackgroundAbstractBis} alt="fond" />
        </div>
        <MovieCard
          title="Sorry I'm Late"
          content="Utilisation de l'API de Twitter"
          projetVideo={SorryImLate}
        />
        <MovieCard
          title="Yoship"
          content="Projet avec Authentification"
          projetVideo={Yoship}
        />
        <MovieCard
          title="WebSocket"
          content="Projet avec les WebSockets"
          projetVideo={Slack_Clone}
        />
        <img src={BackgroundAbstract} alt="fond" />
      </ContainerMorePortfolio>
    </>
  );
};

export default MorePortfolio;
